import { Stack } from "@mui/material";
import { Tag } from "src/components/general/Tag/Tag";
import type { TagItem } from "src/queries/tags/tags.types";
import {
  ADDITIONAL_TAGS,
  MAX_VISIBLE_SELECTED_CHIPS,
} from "../../AssetsFilterTags.constants";

interface SelectedTagsChipsProps {
  selectedTagIds: number[];
  allTags: TagItem[] | undefined;
  onRemoveTag: (tagId: number) => void;
}

export default function SelectedTagsChips({
  selectedTagIds,
  allTags,
  onRemoveTag,
}: SelectedTagsChipsProps) {
  const selectedTags = [...(allTags || []), ...ADDITIONAL_TAGS].filter((t) =>
    selectedTagIds.includes(t.tag_id)
  );

  if (selectedTags.length === 0) return null;

  const visibleTags = selectedTags.slice(0, MAX_VISIBLE_SELECTED_CHIPS);

  return (
    <Stack
      direction="row"
      spacing={0.5}
      className="mask-r-from-[calc(100%-40px)]"
      sx={{
        alignItems: "center",
      }}
    >
      {visibleTags.map((tag) => (
        <Tag
          key={tag.tag_id}
          tag={tag.name}
          onDelete={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRemoveTag(tag.tag_id);
          }}
          onMouseDown={(e) => {
            if ((e.target as HTMLElement).closest(".MuiChip-deleteIcon")) {
              e.stopPropagation();
              e.preventDefault();
            }
          }}
        />
      ))}
    </Stack>
  );
}
